export default {
      id: "ArrowLeft-usage",
      viewBox: "0 0 6 11",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#ArrowLeft",
      toString: function () {
        return this.url;
      }
    }